/**
 * Helper function to parse backup filename and extract date/time in mm/dd/yyyy HH:MM:SS format
 * @param filename - The backup filename to parse
 * @returns Formatted date string with time or original filename if pattern doesn't match
 */
export const getBackupFileLabel = (filename: string): string => {
  // Look for pattern like .backup.MMDDYYHHMMSS
  const backupMatch = filename.match(/\.backup\.(\d{12})/);

  if (backupMatch) {
    const dateTimeStr = backupMatch[1];

    const month = dateTimeStr.substring(0, 2);
    const day = dateTimeStr.substring(2, 4);
    const year = `20${dateTimeStr.substring(4, 6)}`; // Assuming 20XX format
    const hour = dateTimeStr.substring(6, 8);
    const minute = dateTimeStr.substring(8, 10);
    const second = dateTimeStr.substring(10, 12);

    // Return in mm/dd/yyyy format
    return `${month}/${day}/${year} ${hour}:${minute}:${second}`;
  }

  // Fallback to original filename if pattern doesn't match
  return filename;
};
